import * as React from 'react';
import { InboxOutlined } from '@ant-design/icons';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { isDef } from '../../../utils/index';
export var AntdTableEmptyPlaceholder = React.memo(function (props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "ant-empty ant-empty-normal"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ant-empty-image"
  }, !isDef(props.icon) ? /*#__PURE__*/React.createElement(InboxOutlined, null) : typeof props.icon === 'string' ? /*#__PURE__*/React.createElement(LegacyIcon, {
    type: props.icon
  }) : props.icon), /*#__PURE__*/React.createElement("p", {
    className: "ant-empty-description"
  }, !isDef(props.text) ? 'No Data' : props.text));
});